const CALENDAR_SUMMARY = "calplease.com";

export async function createSecondaryCalendar(token) {
  const res = await fetch("https://www.googleapis.com/calendar/v3/calendars", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      summary: CALENDAR_SUMMARY,
    }),
  });

  if (!res.ok) {
    throw new Error("Failed to create secondary calendar");
  }

  const calendar = await res.json();
  return calendar.id;
}

export async function getSecondaryCalendarId(token) {
  const res = await fetch(
    "https://www.googleapis.com/calendar/v3/users/me/calendarList",
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  if (!res.ok) {
    throw new Error("Failed to get calendar id");
  }

  const list = await res.json();

  for (const calendar of list.items) {
    if (calendar.summary === CALENDAR_SUMMARY) {
      return calendar.id;
    }
  }
  return null;
}

export async function createEvent(token, calendarId, calEvent) {
  const res = await fetch(
    `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(calEvent),
    },
  );

  if (!res.ok) {
    throw new Error("Failed to create event");
  }
}
